__turbopack_context__.v({
  "fancy-radio-list": "V2_e4q_fancy-radio-list",
  "form": "V2_e4q_form",
  "icon": "V2_e4q_icon",
  "radio-input": "V2_e4q_radio-input",
  "radio-wrapper": "V2_e4q_radio-wrapper",
});
